import {
  Download1Stroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onSearch?: () => void;
  onRefresh?: () => void;
  onFixedColumns?: () => void;
  onExportData?: () => void;
  onEditPrintTemplate?: () => void;
  className?: string;
  fromDate?: string;
  toDate?: string;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onSearch,
  onRefresh,
  onFixedColumns,
  onExportData,
  onEditPrintTemplate,
  className,
  fromDate,
  toDate
}) => {
  return (
    <ActionBarV2
      className={className}
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Kiểm tra tình trạng hóa đơn điện tử</h1>
          <span className='flex items-center justify-center text-xs font-semibold text-gray-500'>
            <div className='mr-2 size-2 rounded-full bg-red-500' />
            Danh sách chứng từ chờ phát hành từ ngày {fromDate} đến ngày {toDate}
          </span>
        </div>
      }
    >
      {onSearch && <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearch} variant='primary' />}

      {onRefresh && (
        <ActionButtonV2
          icon={RefreshCircle1ClockwiseStroke}
          title='Refresh'
          onClick={onRefresh}
          variant='destructive'
        />
      )}
      {onFixedColumns && (
        <ActionButtonV2 icon={SignPostLeftStroke} title='Cố định cột' onClick={onFixedColumns} variant='secondary' />
      )}
      {onExportData && (
        <ActionButtonV2 icon={Download1Stroke} title='Kết xuất dữ liệu' onClick={onExportData} variant='secondary' />
      )}
      <MenuButtonV2
        items={[
          {
            title: 'Chỉnh sửa mẫu in',
            icon: <AritoIcon icon={864} />,
            onClick: onEditPrintTemplate,
            group: 0
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
